module.exports = __webpack_public_path__ + "img/CST-S.44e307ca.png";